module.exports = __webpack_public_path__ + "img/downarrow.69c43e26.svg";